/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';

export function getDefaultPopupSize(): ResponsiveConf {
    return {
        updateHeight: true,
        updateWidth: true,
        box: {x: '50%', y: '163px', width: '906px', height: '1356px'},
        translate: {x: '-50%'}
    };
}